import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { stripInvalidHTML } from 'site-modules/shared/utils/strip-html';
import { ViewMore } from 'site-modules/shared/components/inventory/view-more/view-more';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

export function RestrictionItem({ isCollapsed = false, className = null, restrictions = '' }) {
  if (!restrictions) return null;
  if (isCollapsed) {
    return (
      <div className="restrictions">
        <ViewMore
          expandedSummary={<span className="text-underline">Requirements & Restrictions</span>}
          collapsedSummary={<span className="text-underline">Requirements & Restrictions</span>}
          className={classnames('size-16 text-cool-gray-30 mb-0_5', className)}
          iconClasses="medium text-cool-gray-30"
        >
          <ContentFragment componentToUse="div" classes={classnames('size-14 text-cool-gray-40', className)}>
            {stripInvalidHTML(restrictions)}
          </ContentFragment>
        </ViewMore>
      </div>
    );
  }
  return (
    <>
      <div className="size-16 text-cool-gray-30 text-underline mb-0_5">Requirements & Restrictions</div>
      <ContentFragment componentToUse="div" classes={classnames('size-14 text-cool-gray-40', className)}>
        {stripInvalidHTML(restrictions)}
      </ContentFragment>
    </>
  );
}

RestrictionItem.propTypes = {
  restrictions: PropTypes.string,
  isCollapsed: PropTypes.bool,
  className: PropTypes.string,
};
